export default function Menu(theme) {
  return {
    MuiMenu: {
      styleOverrides: {
        // root: {
        //   margin: "4px",
        //   borderRadius: "8px",
        //   "&:hover": {
        //     background: theme.palette.grey.gm,
        //   },
        // },
        paper: {
          boxShadow:
            "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
          // background: theme.palette.grey.g7,
        },
      },
    },
  };
}
